const phoneValidator = (rule, value, callback) => {
    if (value && !/^[0-9]{10,11}$/.test(value)) {
        callback('Please enter the correct telephone number!');
    } else {
        callback();
    }
};

// Optional whole-number field: blank passes; otherwise it must be an integer
const wholeNumberValidator = msg => (rule, value, callback) => {
    if (value === undefined || value === null || value === '') {
        callback();
    } else if (!/^-?\d+$/.test(String(value).trim())) {
        callback(msg || 'Please enter a whole number');
    } else {
        callback();
    }
};

const required = msg => ({
    required: true,
    message: msg
});

const isEmail = msg => ({
    type: 'email',
    message: msg || 'Please enter the correct email!'
});

const phone = msg => ({
    validator: phoneValidator
});

const wholeNumber = msg => ({
    validator: wholeNumberValidator(msg)
});

export { required, isEmail, phone, wholeNumber };
